import * as Icons from "@/assets/features/requistion";
import { VIEW_CANDIDATE_MODAL_KEYS } from "../constant/constant";
import { useJobRequisitionStore } from "../store/useJobRequisitionStore";
import { ConfirmationModal } from "@/components/shared/modals/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import AssignHiringTeamModal from "@/components/shared/comman/modals/AssignHiringTeamModal";

const ApproveModal = () => {
  const navigate = useNavigate();
  const { setActionModal, actionModal ,handleConfirmationClose} = useJobRequisitionStore();


  return (
    <>
      {/* =========================== */}
      <ConfirmationModal
        open={actionModal === VIEW_CANDIDATE_MODAL_KEYS.APPROVE}
        onOpenChange={handleConfirmationClose}
        icon={<Icons.Done className="w-17 h-17" />}
        title="Approve?"
        description="Are you sure you want to approve this requisition?"
        confirmLabel="Confirm"
        cancelLabel="Cancel"
        onConfirm={() => {
          setActionModal(VIEW_CANDIDATE_MODAL_KEYS.NONE);

          setTimeout(() => {
            setActionModal(VIEW_CANDIDATE_MODAL_KEYS.APPROVE_SUCCESS);
          }, 80);
        }}
      />

      {/*================APPROVE_SUCCESS============ */}
      <ConfirmationModal
        open={actionModal === VIEW_CANDIDATE_MODAL_KEYS.APPROVE_SUCCESS}
        onOpenChange={handleConfirmationClose}
        icon={<Icons.Done className="w-15 h-15" />}
        classNameFooter="!flex-col"
        title="requisition approved"
        confirmLabel="assign recruiter"
        cancelLabel="back to requisition history"
        onConfirm={() => {
          setActionModal(VIEW_CANDIDATE_MODAL_KEYS.ASSIGN);
        }}
        onCancel={() => {
          navigate("/job-requisition/history");
          setActionModal(VIEW_CANDIDATE_MODAL_KEYS.NONE);
        }}
      />
      {/* ============= Assign Modals */}
      <AssignHiringTeamModal />
    </>
  );
};

export default ApproveModal;
